import React from 'react'
import { FormFeedback, Input } from 'reactstrap'
import api from '../../../api/api'
import ParadigmaModal from '../../../components/ParadigmaModal/ParadigmaModal'

export default class Modal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dependencia: '',
            errors: {},
        }
    }

    resetState = () => {
        this.setState({
            dependencia: '',
            errors: {}
        })
    }
    setData = (data) => {
      this.setState({dependencia: data.nombre})
    }
    getData = () => {
        return {dependencia: this.state.dependencia}
    }

    onValidation = () => {
        if(!!!this.state.dependencia){
            this.setState({errors: {dependencia: "Ingrese un campo válido."}})
            return false
        }
        return true
    }
    onChangeDependencia = (value) => {
        this.setState(prevState => ({
            dependencia: value,
            errors: {
                ...prevState.errors,
                dependencia: null
            }
        }))
    }
    getModalVars = () => {
      const { action, onClose } = this.props;
      if (this.props.action=='CREATE'){
        return {
          action: action,
          postUrl: api.proyectos.cargadatos.convenios.dependencias.create,
          buttonTitle: "Nuevo",
          onClose: () => this.resetState() & (onClose && onClose()),
          onPreSubmit: () => this.getData(),
          onValidation: () => this.onValidation(),
          onSubmit: this.props.onSubmit,
          disabled: false,
          successMessage: "La dependencia ha sido creada con éxito.",
          title: "Nueva dependencia",
          buttonIcon: "fa fa-plus fa-lg",
          saveButton: true,
          closeButton: true,
          className: "ui-modal-dialog",
        }
    }
      else if (action == "EDIT") {
          return {
              action,
              getUrl: api.proyectos.cargadatos.convenios.dependencias.detail,
              postUrl: api.proyectos.cargadatos.convenios.dependencias.edit,
              id: this.props.id,
              onGotData: (data) => this.setData(data),
              onPreSubmit: () => this.getData(),
              onClose: () => this.resetState() & (onClose && onClose()),
              onSubmit: this.props.onSubmit,
              disabled: false,
              title: "Editar la dependencia",
              successMessage: "La dependencia ha sido editada con éxito.",
              buttonIcon: "fa fa-pencil fa-lg",
              closeButton: true,
              saveButton: true,
              buttonTitle: "Editar",
              className: "ui-modal-dialog",
          }
      }
    else if (action=="DELETE") {
        return {
          action,
          getUrl: api.proyectos.cargadatos.convenios.dependencias.detail,
          postUrl: api.proyectos.cargadatos.convenios.dependencias.delete,
          id: this.props.id,
          onGotData: (data) => this.setData(data),
          onClose: () => this.resetState() & (onClose && onClose()),
          onSubmit: this.props.onSubmit,
          disabled: true,
          title: "Eliminar dependencia",
          successMessage: "La dependencia ha sido eliminada con éxito.",
          buttonIcon: "fa fa-trash fa-lg",
          danger: true,
          closeButton: true,
          saveButton: true,
          buttonClass: "btn-danger",
          saveButtonLabel: "Eliminar",
          buttonTitle: "Eliminar",
          className: "ui-modal-dialog",
        }
    }
  }
  render(){
        const modalVars=this.getModalVars();
        const {errors, dependencia} = this.state
      return (
          <ParadigmaModal {...modalVars}>
            <div className="ui-form">
                {this.props.action=="DELETE" &&
                    <div className="ui-alert ui-alert-danger">
                        Esta acción eliminará la dependencia seleccionada.
                    </div>
                }
                <section className="ui-section-block">
                    <h5 className="ui-section-label">Dependencia</h5>
                    <div className="ui-row-1">
                        <div className="ui-field">
                            <label>Nombre</label>
                            <Input
                                name="dependencia"
                                autoFocus={!modalVars.disabled}
                                data-auto-focus={!modalVars.disabled ? "true" : null}
                                value={dependencia}
                                onChange={(evt) => this.onChangeDependencia(evt.target.value)}
                                disabled={modalVars.disabled}
                            />
                            <FormFeedback className={(errors.dependencia != undefined ? "d-block" : "")}>{errors.dependencia}</FormFeedback>
                        </div>
                    </div>
                </section>
            </div>
        </ParadigmaModal>
      )
  }
}



// WEBPACK FOOTER //
// ./src/views/Convenios/Dependencias/Modal.js